import React from "react";
import Icon from "../Icon";
import ProgressBar from "../ProgressBar";
import { EXTRA_NEW_WORDS_STEP } from "./todaysPlanService";

const ProBanner = () => (
  <div className="alert alert-success tw-flex tw-items-center tw-justify-between tw-gap-3" style={{ marginBottom: 0 }}>
    <span>Want to learn more words per day?</span>
    <a className="btn btn-success joystix" href="/pro">Try Pro</a>
  </div>
);

const MoreWords = ({ onAddMoreWords }) => (
  <div className="tw-flex tw-flex-col tw-gap-2">
    <small className="text-secondary">Want to add more words to today's plan?</small>
    <button className="btn btn-success btn-lg btn-block joystix" data-testid="todays-plan-add-more-words" onClick={onAddMoreWords}>
      +{EXTRA_NEW_WORDS_STEP} words
    </button>
  </div>
);

const KeepLearningNote = () => (
  <div className="alert alert-success" style={{ marginBottom: 0 }}>
    <small>✨ You can still keep learning by playing reviews or new words directly from the collections below.</small>
  </div>
);

function NextStep({ hasMoreNewWords, isPro, onAddMoreWords }) {
  if(!isPro) return <ProBanner />;
  return hasMoreNewWords ? <MoreWords onAddMoreWords={onAddMoreWords} /> : <KeepLearningNote />;
}

export default function TodaysPlanCompleteBanner({
  completedItems,
  freeCardsRemaining,
  hasMoreNewWords,
  isPro,
  onAddMoreWords,
  onDismiss,
  totalItems,
  untappedReviews
}) {
  const percent = totalItems > 0 ? Math.min(100, Math.round((completedItems / totalItems) * 100)) : 0;
  const hasFreeCardsLeft = !isPro && freeCardsRemaining > 0;

  return (
    <div className="tw-flex tw-flex-col tw-gap-5" data-testid="todays-plan-complete-banner">
      <div className="tw-flex tw-flex-col tw-gap-2">
        <div className="tw-flex tw-items-center tw-justify-between tw-gap-3">
          <div className="tw-flex tw-items-center tw-gap-3">
            <Icon name="trophy" style={{ color: "#f4b73b", fontSize: 28 }} type="fa" />
            <span className="joystix" style={{ fontSize: 20 }}>Goal Complete!</span>
          </div>
          <button aria-label="Dismiss" className="close" data-testid="todays-plan-complete-dismiss" onClick={onDismiss} type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <p className="text-secondary" data-testid="complete-banner-subtitle" style={{ marginBottom: 0 }}>
          {hasFreeCardsLeft
            ? `You still have ${freeCardsRemaining} free sentences left today. Keep playing reviews or new words from the collections below!`
            : "Consistency is key! Take a well-earned break and come back tomorrow!"}
        </p>
      </div>

      <div>
        <ProgressBar percent={percent} style={{ height: 10, marginBottom: 4 }} />
        <small className="text-secondary" data-testid="todays-plan-complete-numerical-progress"><strong>{completedItems}</strong>/{totalItems} played</small>
      </div>

      {!isPro && untappedReviews > 0 && (
        <small className="text-secondary" data-testid="complete-banner-untapped-reviews">{untappedReviews} reviews are waiting in your queue.</small>
      )}

      <NextStep hasMoreNewWords={hasMoreNewWords} isPro={isPro} onAddMoreWords={onAddMoreWords} />
    </div>
  );
}
